import {Component, Input, ViewEncapsulation} from '@angular/core';
import {MatDialog, PageEvent} from "@angular/material";
import {kanServicesService} from "../../../../services/services/services";
import {Service} from "../../../../../classes/service";
import {kanServiceDialog} from "../../../dialogs/service-dialog/component";
import {kanAuthService} from "../../../../services/services/auth";

@Component({
    selector: 'kan-services',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanServices {
    @Input() selectedTab: number;
    public services: Service[];
    public filteredServices: Service[];
    public pagedServices: Service[];
    public search: string;
    public typeDog: boolean = true;
    public typeUser: boolean = true;
    public pageIndex: number = 0;
    public pageSize: number = 20;

    constructor(private dialog: MatDialog,
                private authService: kanAuthService,
                private servicesService: kanServicesService) {

    }

    ngOnInit(): void {

    }

    ngOnChanges(changes): void {
        if (changes.selectedTab.currentValue === 0) {
            this.getServices();
        }
    }

    get role(): string {
        return this.authService.role;
    }

    public getServices(): void {
        this.servicesService.getServices()
            .then((services) => {
                this.services = services;
                this.filter();
            })
            .catch((error) => {
                console.log(error);
            })
    }

    public openDialog(event: any) {
        let dialogRef = this.dialog.open(kanServiceDialog, {
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'add') {
                this.getServices();
            }
        });
    }

    public changePage(event: PageEvent) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.pageServices();
    }

    pageServices() {
        this.pagedServices = this.filteredServices.slice(this.pageIndex * this.pageSize, (this.pageIndex + 1) * this.pageSize);
    }

    public filter() {
        this.filteredServices = this.services.filter((service) => {
            let found = true;

            if (this.search) {

                let arr = this.search.split(' ');

                arr.forEach((item) => {

                    if (item) {
                        found = found &&
                            (
                                String(service.service).toLowerCase().indexOf(item.toLocaleLowerCase()) > -1 ||
                                String(service.description).toLowerCase().indexOf(item.toLocaleLowerCase()) > -1
                            );
                    }
                });
            }

            if (found && !this.typeDog && service.type === 'DOG') {
                found = false;
            }

            if (found && !this.typeUser && service.type === 'USER') {
                found = false;
            }

            return found;
        });

        this.pageServices();
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/service/services/component.ts